import { postFormData, postJson } from "../Utils/apiUtils.js";

const formatDateValue = (value) => {
  if (!value) return "";

  if (value instanceof Date) {
    const pad = (dateValue) => `${dateValue}`.padStart(2, "0");
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(
      value.getDate()
    )}`;
  }

  return String(value).slice(0, 10);
};

const mapNationToCode = (nation) => (nation === 0 ? "kr" : "99");
const mapCodeToNation = (cCode) => (cCode === "kr" ? 0 : 1);

const mapDepartmentBattleEntry = (entry = {}) => ({
  id: String(entry.seasonDepartmentId ?? ""),
  seasonDepartmentId: Number(entry.seasonDepartmentId),
  title: entry.title ?? "",
  description: entry.content ?? "",
  startDate: formatDateValue(entry.startTime),
  endDate: formatDateValue(entry.endTime),
  regTime: entry.regTime ?? "",
  nation: mapCodeToNation(entry.cCode),
  targetRate: Number(entry.goalRate ?? 150),
  noDataStepType: Number(entry.noDataStepType ?? 1),
  noDataStepValue:
    entry.noDataStepValue === null || entry.noDataStepValue === undefined
      ? ""
      : String(entry.noDataStepValue),
  isVisible: Number(entry.status ?? 1) === 1,
  imageUrl: entry.image ?? "",
  rownum: Number(entry.rownum ?? 0),
});

const buildDepartmentBattleFormData = ({ form, seasonDepartmentId = null }) => {
  const formData = new FormData();
  const imageFile =
    Array.isArray(form.image) && form.image[0] ? form.image[0] : null;

  formData.append("title", form.title.trim());
  formData.append("content", form.description.trim());
  formData.append("startTime", formatDateValue(form.startDate));
  formData.append("endTime", formatDateValue(form.endDate));
  formData.append("cCode", mapNationToCode(form.nation));
  formData.append(
    "goalRate",
    form.targetRate === null ? "" : String(form.targetRate)
  );
  formData.append("noDataStepType", String(form.noDataStepType ?? 1));
  formData.append(
    "noDataStepValue",
    form.noDataStepType === 2 && form.noDataStepValue !== ""
      ? String(form.noDataStepValue)
      : ""
  );
  formData.append("status", form.isVisible ? "1" : "0");
  formData.append("menuType", "1");
  formData.append("menuTitle", "");

  if (seasonDepartmentId) {
    formData.append("seasonDepartmentId", String(seasonDepartmentId));
  }

  if (imageFile) {
    formData.append("image", imageFile);
  }

  return formData;
};

export const requestDepartmentBattleList = async ({
  page,
  offset,
  searchTitle,
  navigate,
}) => {
  const response = await postJson(
    "/dashboard/departmentBattle/getList",
    {
      page,
      offset,
      searchTitle: searchTitle?.trim() ?? "",
    },
    navigate
  );

  if (response.code !== 200) {
    return response;
  }

  return {
    ...response,
    data: {
      count: Number(response.data?.count ?? 0),
      rows: Array.isArray(response.data?.rows)
        ? response.data.rows.map(mapDepartmentBattleEntry)
        : [],
    },
  };
};

export const requestDepartmentBattleDetail = async ({
  seasonDepartmentId,
  navigate,
}) => {
  const response = await postJson(
    "/dashboard/departmentBattle/getDetail",
    { seasonDepartmentId },
    navigate
  );

  if (response.code !== 200) {
    return response;
  }

  return {
    ...response,
    data: mapDepartmentBattleEntry(response.data),
  };
};

export const requestDeleteDepartmentBattle = async ({
  seasonDepartmentId,
  navigate,
}) =>
  postJson(
    "/dashboard/departmentBattle/delete",
    { seasonDepartmentId },
    navigate
  );

export const requestCreateDepartmentBattle = async ({ form, navigate }) =>
  postFormData(
    "/dashboard/departmentBattle/create",
    buildDepartmentBattleFormData({ form }),
    navigate
  );

export const requestUpdateDepartmentBattle = async ({
  seasonDepartmentId,
  form,
  navigate,
}) =>
  postFormData(
    "/dashboard/departmentBattle/update",
    buildDepartmentBattleFormData({ form, seasonDepartmentId }),
    navigate
  );
